import { render, staticRenderFns } from "./ChatMessageTagItems.vue?vue&type=template&id=785c3563&scoped=true&"
import script from "./ChatMessageTagItems.vue?vue&type=script&lang=js&"
export * from "./ChatMessageTagItems.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pc/trainer_tag.css?vue&type=style&index=0&id=785c3563&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785c3563",
  null
  
)

export default component.exports